import React from 'react'

export const CloseIcon = () => (
  <svg width="40" height="40">
    <g fill="none" fillRule="evenodd">
      <rect width="40" height="40" fill="#F6F5F4" rx="16" />
      <path
        fill="#AB9F94"
        d="M14.343 14.343a1 1 0 011.414 0L20 18.586l4.243-4.243a1 1 0 011.414 1.414l-4.243 4.244 4.243 4.242a1 1 0 01-1.414 1.414l-4.244-4.242-4.242 4.242a1 1 0 01-1.414-1.414L18.586 20l-4.243-4.243a1 1 0 010-1.414z"
      />
    </g>
  </svg>
)
